import { Avatar } from "@material-ui/core";
import React from "react";
import formatDate from "../../../../utils/fomat/formatDate";

const tabConfig = [
  {
    columnTitle: "",
    dataField: ["component"],
    component: ({ values }) => {
      return <Avatar src={values.coverURL} variant="rounded" />;
    },
  },
  {
    columnTitle: "Name",
    dataField: ["name"],
  },
  {
    columnTitle: "Description",
    dataField: ["description"],
  },
  {
    columnTitle: "Start Date",
    dataField: ["startTime"],
  },
  {
    columnTitle: "End Date",
    dataField: ["endTime"],
  },
];

export default tabConfig;
